import { render, staticRenderFns } from "./CheckBoxInputCommon.vue?vue&type=template&id=7139b99c&scoped=true&"
import script from "./CheckBoxInputCommon.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxInputCommon.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBoxInputCommon.vue?vue&type=style&index=0&id=7139b99c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7139b99c",
  null
  
)

export default component.exports